module.exports = __webpack_public_path__ + "img/wellness-cloud-logo.474f9a5.svg";